/**
 * Copyright (c) 2025 Répét Contributors
 * Licensed under the MIT License
 * See LICENSE file in the project root for full license text
 */

import { useOnlineStatus } from '../../hooks/useOnlineStatus'

interface Props {
  className?: string
  /** @deprecated — conservé pour compatibilité, ignoré (toujours compact) */
  compact?: boolean
}

export function OnlineStatusBadge({ className = '' }: Props) {
  const { isOnline } = useOnlineStatus()

  if (isOnline) return null

  return (
    <span
      role="status"
      aria-label="Statut réseau : hors ligne"
      data-testid="online-status-badge"
      data-online={false}
      className={`inline-flex items-center ${className}`}
    >
      <span
        className="inline-block w-2.5 h-2.5 rounded-full bg-orange-400 shadow-[0_0_4px_1px_rgba(251,146,60,0.4)]"
        aria-hidden="true"
      />
    </span>
  )
}
